import {Payments, Reports, MerchantsSchemePS, PaymentSystemsConf, Merchants} from './pages';
import {withNavigationWatcher} from './contexts/navigation';
import {filterRoutesByRights, normalizeUserRights} from './utils/routes-access';

export const appRoutes = [
  {
    path: '/payments',
    text: 'Платежи',
    element: Payments,
  },
  {
    path: '/reports',
    text: 'Отчеты',
    element: Reports,
  },
  {
    path: '/merchants',
    text: 'Мерчанты',
    element: Merchants,
    accessRight: 10,
  },
  {
    path: '/merchants-scheme-ps',
    text: 'Мерчанты-Схема ПС',
    element: MerchantsSchemePS,
    accessRight: 10,
  },
  {
    path: '/payment-systems-conf',
    text: 'Платежные системы (Конф.)',
    element: PaymentSystemsConf,
    accessRight: 10,
  },

];

export function getRoutes(userRights) {
  const normalizedRights = normalizeUserRights(userRights);

  return filterRoutesByRights(appRoutes, normalizedRights).map(route => {
    return {
      ...route,
      element: withNavigationWatcher(route.element, route.path, { userRights: normalizedRights })
    };
  });
}
